/** Savings screen with KPI, demand, vendor, and method sections. */
import '../savings.css';

import { List } from '@kerfjs/ui/list';
import { Row } from '@kerfjs/ui/row';
import { SegmentedControl } from '@kerfjs/ui/segmented-control';
import type { SafeHtml } from 'kerfjs';

import { PageLoading } from '../../components/page-loading.js';
import { orgSavings, savingsBreakdownView, shellSearch } from '../../data/state.js';
import { SavingsByDemand } from './components/savings-by-demand.js';
import { SavingsByMonth } from './components/savings-by-month.js';
import { SavingsByVendor } from './components/savings-by-vendor.js';
import { SavingsKpiGrid } from './components/savings-kpi-grid.js';
import { SavingsMethodNote } from './components/savings-method-note.js';

export function SavingsView(): SafeHtml {
  const savings = orgSavings.value;
  // The selected sidebar period titles the main toolbar; its leading and
  // trailing zones own the site filter and Export menu (HS2-0TNSTH).
  return (
    <section
      class="savings-view"
      data-page-loading={savings === null ? '' : undefined}
      aria-labelledby="savings-period-title"
    >
      {savings === null ? (
        <PageLoading label="Loading savings" />
      ) : (
        <List gap="l" controlInsets="tb">
          <SavingsKpiGrid savings={savings} />
          <List gap="m">
            <Row hAlign="center" controlInsets="rl">
              <SegmentedControl
                id="savings-breakdown-view"
                label="Savings Breakdown"
                value={savingsBreakdownView.value}
                action="savings-breakdown-view"
                appearance="filled"
                shape="rounded"
                layout="equal"
                choices={[
                  { value: 'demand', label: 'By Demand' },
                  { value: 'vendor', label: 'By Vendor' },
                  { value: 'month', label: 'By Month' },
                ]}
              />
            </Row>
            {savingsBreakdownView.value === 'demand' ? (
              <SavingsByDemand savings={savings} query={shellSearch.value} />
            ) : savingsBreakdownView.value === 'vendor' ? (
              <SavingsByVendor savings={savings} query={shellSearch.value} />
            ) : (
              <SavingsByMonth savings={savings} />
            )}
          </List>
          <SavingsMethodNote method={savings.method} />
        </List>
      )}
    </section>
  );
}
